import { X } from 'lucide-preact';
import { GeospatialSidebarFilters } from '../../components/geospatial-intelligence-page';
import type { GeospatialFilterOptions } from '../../components/geospatial-intelligence-page';
import { GEOSPATIAL_PAGE } from './geospatial.config';

interface GeospatialFiltersDialogProps {
  open: boolean;
  onClose: () => void;
  showAllRisks: boolean;
  onShowAllRisksChange: (showAll: boolean) => void;
  toggleDisabled: boolean;
  country: string;
  onCountryChange: (value: string) => void;
  city: string;
  onCityChange: (value: string) => void;
  sourceType: string;
  onSourceTypeChange: (value: string) => void;
  originator: string;
  onOriginatorChange: (value: string) => void;
  operatingMode: string;
  onOperatingModeChange: (value: string) => void;
  riskCategory: string;
  onRiskCategoryChange: (value: string) => void;
  impactTarget: string;
  onImpactTargetChange: (value: string) => void;
  publicationFromIndex: number;
  publicationToIndex: number;
  onPublicationFromIndexChange: (value: number) => void;
  onPublicationToIndexChange: (value: number) => void;
  options: GeospatialFilterOptions;
}

export function GeospatialFiltersDialog({
  open,
  onClose,
  showAllRisks,
  onShowAllRisksChange,
  toggleDisabled,
  country,
  onCountryChange,
  city,
  onCityChange,
  sourceType,
  onSourceTypeChange,
  originator,
  onOriginatorChange,
  operatingMode,
  onOperatingModeChange,
  riskCategory,
  onRiskCategoryChange,
  impactTarget,
  onImpactTargetChange,
  publicationFromIndex,
  publicationToIndex,
  onPublicationFromIndexChange,
  onPublicationToIndexChange,
  options,
}: GeospatialFiltersDialogProps) {
  if (!open) return null;

  return (
    <div
      className="geo-filters-dialog geospatial-filters-popup"
      role="dialog"
      aria-label={GEOSPATIAL_PAGE.filtersDialogLabel}
    >
      <div className="geo-filters-dialog__header geospatial-filters-popup__header">
        <h3 className="geo-filters-dialog__title geospatial-filters-popup__title">
          {GEOSPATIAL_PAGE.filtersLabel}
        </h3>
        <button
          type="button"
          className="geo-filters-dialog__close geospatial-filters-popup__close"
          onClick={onClose}
          aria-label="Close filters"
        >
          <X size={18} aria-hidden />
        </button>
      </div>
      <div className="geo-filters-dialog__body geospatial-filters-popup__body">
        <GeospatialSidebarFilters
          showAllRisks={showAllRisks}
          onShowAllRisksChange={onShowAllRisksChange}
          toggleDisabled={toggleDisabled}
          toggleHint={GEOSPATIAL_PAGE.scopeToggleHint}
          country={country}
          onCountryChange={onCountryChange}
          city={city}
          onCityChange={onCityChange}
          sourceType={sourceType}
          onSourceTypeChange={onSourceTypeChange}
          originator={originator}
          onOriginatorChange={onOriginatorChange}
          operatingMode={operatingMode}
          onOperatingModeChange={onOperatingModeChange}
          riskCategory={riskCategory}
          onRiskCategoryChange={onRiskCategoryChange}
          impactTarget={impactTarget}
          onImpactTargetChange={onImpactTargetChange}
          publicationFromIndex={publicationFromIndex}
          publicationToIndex={publicationToIndex}
          onPublicationFromIndexChange={onPublicationFromIndexChange}
          onPublicationToIndexChange={onPublicationToIndexChange}
          options={options}
        />
      </div>
    </div>
  );
}
